export enum CommunicationsPostActions {
  Edit = 1,
  Inactive = 2,
  Active = 3,
  Delete = 4
}
